/**
 * Display-only formatting for submission/sample source text.
 *
 * The source can be HML XML or a FHIR JSON bundle. XML already carries its own
 * line breaks and must be shown verbatim (the edit/resubmit flow operates on the
 * raw text, and XML whitespace can be significant). JSON bundles arrive as a
 * single line, so when the content parses as JSON it is pretty-printed for
 * readability only.
 *
 * This never mutates the caller's data: it returns a formatted copy for display,
 * and for any non-JSON or unparseable input it returns the original string
 * unchanged.
 *
 * @param raw the raw source string as received from the server
 * @returns a display string (indented JSON when applicable, otherwise verbatim)
 */
export function formatSourceForDisplay(raw: string | null | undefined): string {
    if (!raw) {
        return '';
    }
    const trimmed = raw.trim();
    // Only attempt JSON formatting for obvious JSON payloads; leave XML/HML alone.
    if (trimmed.startsWith('{') || trimmed.startsWith('[')) {
        try {
            return JSON.stringify(JSON.parse(trimmed), null, 2);
        } catch {
            return raw;
        }
    }
    return raw;
}
